import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectShowAbandonModal = createSelector(
  [(store: RootState) => store.documentShow.showAbandonModal],
  (data) => data
);
